import api from './api';

/**
 * Plan de cuentas (/api/plan-cuentas)
 * Usado por la página /plan-cuentas: el plan del SII con nuestras cuentas y las propuestas
 * de cuentas nuevas del usuario conectado.
 */

export const getPlanCuentas = () =>
  api.get('/api/plan-cuentas').then(r => r.data.data);

export const getConceptosF22 = () =>
  api.get('/api/plan-cuentas/conceptos-f22').then(r => r.data.data);

export const getMisPropuestas = () =>
  api.get('/api/plan-cuentas/propuestas').then(r => r.data.data);

export const crearPropuesta = (propuesta) =>
  api.post('/api/plan-cuentas/propuestas', propuesta).then(r => r.data.data);
